export function normalizeAgentName (value) {
  return typeof value === 'string' ? value.replace(/\s+/g, '') : ''
}

export function normalizeIdCardNumber (value) {
  return typeof value === 'string'
    ? value.replace(/\s+/g, '').replace(/x$/i, 'X')
    : ''
}

export function isSimpleIdCardNumber (value) {
  return /^\d{17}[\dX]$/.test(normalizeIdCardNumber(value))
}

export function maskIdCardNumber (value) {
  const normalizedValue = normalizeIdCardNumber(value)
  if (!normalizedValue) return '--'
  if (normalizedValue.length <= 10) return normalizedValue

  return `${normalizedValue.slice(0, 6)}${'*'.repeat(normalizedValue.length - 10)}${normalizedValue.slice(-4)}`
}
